import { useMemo } from 'react'

import { ContactFormContent } from 'clickNgo/entities/contact'
import { useGetFormDataField } from 'cng-common/features/form'

import { ContactEditorFormKeys } from '../../../../configs'

export const useContactBasicInfoValidate = () => {
  const [, , isWorkPhoneCodeModified] = useGetFormDataField<number>(
    ContactEditorFormKeys.common,
    ContactFormContent.fields.workPhoneCode.field
  )

  const [, , isWorkPhoneNumberModified] = useGetFormDataField<number>(
    ContactEditorFormKeys.common,
    ContactFormContent.fields.workPhoneNumber.field
  )

  const generalValidationProps = useMemo(
    () => ({
      isFirstNameRequired: true,
      isLastNameRequired: true,
      isEmailRequired: true,
    }),
    []
  )

  const commonValidationProps = useMemo(
    () => ({
      isWorkPhoneCodeRequired: isWorkPhoneCodeModified || isWorkPhoneNumberModified,
      isWorkPhoneNumberRequired: isWorkPhoneNumberModified,
    }),
    [isWorkPhoneCodeModified, isWorkPhoneNumberModified]
  )

  return {
    generalValidationProps,
    commonValidationProps,
  }
}
